export default __webpack_public_path__ + "static/media/check-new.012418d9.svg";